// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"90fdb950","404":"de9215fc","498":"82380afd"}[chunkId] + ".chunk.js";
};